import React, { Fragment } from "react"
import _map from "lodash/map"
import _isEmpty from "lodash/isEmpty"
import PropTypes from "prop-types"

import ModernModal from "shared/components/ModernModal"
import Typograph from "../../../../components/Typograph"
import Description from "../Description"
import DescriptionList from "../DescriptionList"

import styles from "./styles.css"

const ProtocolDetailsModal = ({
  isOpen,
  onClose,
  generalProtocolDetails,
  protocolDetails,
  t
}) => {
  const isStatusCancel =
    !_isEmpty(protocolDetails) &&
    protocolDetails.fields[0].stringFieldValue === "CANCELAR"

  return (
    <ModernModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onClose}
      customModalClass={styles.customModalClass}
      removeButton
      confirmButtonText="Fechar"
    >
      <Typograph htmlTag="h1" size="medium" color="outer_space" weight="bold">
        {t("PROTOCOL_DETAIL")}
      </Typograph>
      <Description className={styles.detailsClass}>
        {_map(generalProtocolDetails.details, (item) => (
          <DescriptionList
            key={`description-${item.key}`}
            description={item.key}
            value={item.value}
          />
        ))}
      </Description>

      {!isStatusCancel && (
        <Fragment>
          {_map(generalProtocolDetails.phoneDetails, (phone) => (
            <Description className={styles.detailsClass}>
              {_map(phone.infoNumber, (item) => (
                <DescriptionList
                  key={`description-${item.key}`}
                  description={item.key}
                  value={item.value}
                />
              ))}
            </Description>
          ))}
        </Fragment>
      )}
    </ModernModal>
  )
}
ProtocolDetailsModal.propTypes = {
  isOpen: PropTypes.boolean,
  onClose: PropTypes.func,
  generalProtocolDetails: PropTypes.object,
  protocolDetails: PropTypes.object,
  t: PropTypes.func
}
export default ProtocolDetailsModal



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/components/ProtocolDetailsModal/index.js